/**
 * Human-readable item ids (KEY-N, e.g. "FR-12").
 *
 * Mirrors deriveVaultTodoListKey / VAULT_TODO_LIST_KEY_MAX in @fias/db-types —
 * the client deliberately doesn't depend on that package, so the key logic is
 * duplicated here. The server re-derives, dedups, and validates on write.
 */

export const LIST_KEY_MAX = 10;

/**
 * Suggest a key prefix from a list name: the initials of a multi-word name
 * ("Fias Roadmap" → "FR"), else the first 4 letters of a single word
 * ("Roadmap" → "ROAD"). Uppercased, alphanumeric only, capped.
 */
export function deriveListKey(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const alnum = (s: string): string => s.replace(/[^A-Za-z0-9]/g, '');
  let key: string;
  if (words.length >= 2) {
    key = words.map((w) => alnum(w).charAt(0)).join('');
  } else {
    key = alnum(words[0] ?? '').slice(0, 4);
  }
  return key.toUpperCase().slice(0, LIST_KEY_MAX) || 'LIST';
}

/** Normalize raw key input as the user types: uppercase, alphanumeric, capped. */
export function sanitizeKeyInput(raw: string): string {
  return raw
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase()
    .slice(0, LIST_KEY_MAX);
}

/** The display id for an item, e.g. "FR-12". */
export function formatItemId(itemKey: string, seq: number): string {
  return `${itemKey}-${seq}`;
}
